import { render, staticRenderFns } from "./MtCasesList.vue?vue&type=template&id=b6f53dde&scoped=true&"
import script from "./MtCasesList.vue?vue&type=script&lang=js&"
export * from "./MtCasesList.vue?vue&type=script&lang=js&"
import style0 from "./MtCasesList.vue?vue&type=style&index=0&id=b6f53dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f53dde",
  null
  
)

export default component.exports